import { Component, inject } from "@angular/core"
import { AuthService } from "@services/auth.service"
import { LogsService } from "@services/logs.service"
import { ProgramPubDTO, ProgramPublishedService } from "@services/program.published.service"
import { Router, RouterLink } from "@angular/router"

@Component({
  selector: "app-home-list-programs",
  standalone: true,
  imports: [RouterLink],
  templateUrl: "./home-list-programs.component.html",
  styleUrl: "./home-list-programs.component.scss",
})
export class HomeListProgramsComponent {
  authService = inject(AuthService)
  logsService = inject(LogsService)
  programPublishedService = inject(ProgramPublishedService)
  router = inject(Router)

  programs: Array<ProgramPubDTO> = []
  isLoading = true

  async ngOnInit() {
    const uid = await this.authService.getCurrentUserUidAsync()
    if (!uid) {
      this.router.navigateByUrl("/")
      return
    }
    const programs = await this.programPublishedService.getMyPrograms(uid)
    if (programs && programs?.length > 0) {
      this.programs = programs
    } else {
      const programIds = await this.logsService.getMyPrograms(uid)
      this.programs = await Promise.all(
        programIds.filter((i) => i !== "").map((programId) => this.programPublishedService.get(programId))
      )
      await this.programPublishedService.setMyPrograms(uid, this.programs)
    }
    this.isLoading = false
  }

  async signOut() {
    await this.authService.signOut(this.programPublishedService.currentProgram?.id || "")
    this.router.navigateByUrl("/")
  }
}
